import React from 'react'
import { trimValues } from 'lib/helpers/forms'
import { toBooleanOrNull } from '../../../../lib/helpers/parent/forms'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      createPickupPerson, // via withMutation
      form: reduxForm // via withRedux
    } = props

    const form = trimValues(reduxForm)

    // perform GraphQL mutation
    const handleSubmit = e => {
      e.preventDefault()

      createPickupPerson({
        variables: {
          input: {
            firstName: form.firstName,
            lastName: form.lastName,
            relationshipToCampers: form.relationshipToCampers,
            legalGuardian: toBooleanOrNull(form.legalGuardian),
            primaryPhone: form.primaryPhone,
            alternatePhone: form.alternatePhone
          }
        }
      })
    }

    return <WrappedComponent handleSubmit={handleSubmit} {...props} />
  }
}

export default withEventHandlers
